import React from "react";
import "./Menu.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assests/sendcheap-logo.png";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Features", to: "/#services", scroll: true },
  { label: "About Us", to: "/about-us" },
  { label: "APIs", to: "/apis" },
  { label: "Contact", to: "/contact" },
];

const Menu = ({ clicked, setClicked }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const close = () => setClicked(false);

  const handleFeaturesClick = (e) => {
    e.preventDefault();
    close();
    if (location.pathname === "/") {
      setTimeout(() => {
        document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
      }, 600);
    }
  };

  return (
    <div className="menu-overlay">
      <div className="menu-drawer">
        {/* Header */}
        <div className="menu-header">
          <img src={Logo} alt="Sendcheap" className="menu-logo" />
          <button className="menu-close" onClick={close} aria-label="Close menu">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line x1="3" y1="3" x2="17" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              <line x1="17" y1="3" x2="3" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Nav links */}
        <nav className="menu-nav">
          {navItems.map((item) =>
            item.scroll ? (
              <a
                key={item.label}
                href={item.to}
                className="menu-link"
                onClick={handleFeaturesClick}
              >
                <span>{item.label}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                className={({ isActive }) =>
                  `menu-link${isActive ? " menu-link-active" : ""}`
                }
                onClick={close}
                end={item.to === "/"}
              >
                <span>{item.label}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </NavLink>
            )
          )}
        </nav>

        {/* CTA */}
        <div className="menu-cta">
          <a
            href="https://onelink.to/n9hyxn"
            target="_blank"
            rel="noreferrer"
            className="menu-cta-btn"
            onClick={close}
          >
            Open Account
          </a>
        </div>

        {/* App store links */}
        <div className="menu-stores">
          <a
            href="https://play.google.com/store/apps/details?id=com.sendcheap.sendcheap"
            target="_blank"
            rel="noreferrer"
            className="menu-store-badge"
            onClick={close}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.18 23.76a2 2 0 0 0 2.2-.22l12.2-7.05-2.8-2.8-11.6 10.07zM.5 1.16A2 2 0 0 0 0 2.5v19a2 2 0 0 0 .5 1.34l.07.07 10.64-10.64v-.25L.57 1.1l-.07.06zM20.31 10.03l-2.9-1.68-3.14 3.14 3.14 3.14 2.93-1.69a2.08 2.08 0 0 0 0-2.91zM3.18.24L14.78 7.3l-2.8 2.8L.5 1.16A2 2 0 0 1 3.18.24z"/>
            </svg>
            Google Play
          </a>
          <a
            href="https://apps.apple.com/ng/app/sendcheap/id6448403237"
            target="_blank"
            rel="noreferrer"
            className="menu-store-badge"
            onClick={close}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            App Store
          </a>
        </div>

        {/* Social links */}
        <div className="menu-socials">
          <a href="https://web.facebook.com/sendcheap/" target="_blank" rel="noreferrer" className="menu-social">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </a>
          <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target="_blank" rel="noreferrer" className="menu-social">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/reel/DXyqOWvsRGB/" target="_blank" rel="noreferrer" className="menu-social">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <circle cx="12" cy="12" r="4"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Menu;
